import { Routes } from '@angular/router';
import { BatchAuftragSucheComponent } from './shared/suche/batch-auftrag-suche.component';
import { AuftragDetailComponent } from './auftrag/auftrag-detail/auftrag-detail.component';
import { AuftragListComponent } from './auftrag/auftrag-list/auftrag-list.component';
import { AuftragListResolver } from './auftrag/auftrag-list/auftrag-list-resolver';
import { AuftragDetailResolver } from './auftrag/auftrag-detail/auftrag-detail-resolver';
import { AuftragNewComponent } from './auftrag/auftrag-new/auftrag-new.component';
import { canActivateAuthorization } from '../../security/authorization.guard';
import { ErweiterungConfigResponse, PermissionResponse } from '../../core/base-api';
import { canActivateErweiterung } from '../../security/erweiterung.guard';
import { DatePipe } from '@angular/common';
import PermissionsEnum = PermissionResponse.PermissionsEnum;
import ActiveErweiterungenEnum = ErweiterungConfigResponse.ActiveErweiterungenEnum;

export const BatchAuftragRoutes: Routes = [
  {
    path: 'import-export',
    canActivate: [canActivateAuthorization, canActivateErweiterung],
    data: {
      permissions: [PermissionsEnum.DATENEXPORT_ANSICHT, PermissionsEnum.DATENEXPORT_AUFTRAG_ADMIN],
      erweiterung: [ActiveErweiterungenEnum.DATENEXPORT]
    },
    loadChildren: () => routes,
    providers: [AuftragListResolver, AuftragDetailResolver, DatePipe]
  }
];

const routes: Routes = [
  {
    path: '',
    component: BatchAuftragSucheComponent,
    data: {
      breadcrumb: 'stapelverarbeitung.search.breadcrumb',
      breadcrumbStatus: 'firstLevel'
    }
  },
  {
    path: 'list/:searchMode',
    component: AuftragListComponent,
    data: {
      breadcrumb: 'shared.breadcrumb.list',
      breadcrumbStatus: 'secondLevel'
    },
    resolve: {
      entity: AuftragListResolver
    }
  },
  {
    path: 'detail',
    component: AuftragDetailComponent,
    resolve: {
      entry: AuftragDetailResolver
    }
  },
  {
    path: 'new',
    component: AuftragNewComponent,
    canActivate: [canActivateAuthorization],
    data: {
      permissions: [PermissionsEnum.DATENEXPORT_AUFTRAG_ADMIN]
    }
  }
];
